//C:\Users\Ahmad\Desktop\academies\frontend\src\api\academies.js
import axios from "@/axios";

/**
 * 🟢 جلب جميع الأكاديميات (Admin)
 */
export async function fetchAcademies() {
    const response = await axios.get("/api/admin/academies");
    return response.data.academies;
}

/**
 * 🟢 إنشاء أكاديمية جديدة (Admin)
 */
export async function createAcademy(data) {
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
        if (data[key] !== null && data[key] !== undefined) {
            formData.append(key, data[key]);
        }
    });

    const response = await axios.post("/api/admin/academies",formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );

    return response.data.academy;
}


/**
 * 🟢 جلب خطط الأدمن
 */
export async function fetchAdminPlans() {
    const response = await axios.get("/api/admin/plans");
    return response.data.plans;
}

/**
 * 🟢 إنشاء خطة جديدة (Admin)
 */
export async function createAdminPlan(data) {
    const response = await axios.post("/api/admin/plans", data);
    return response.data.plan;
}

/**
 * 🟢 تحديث خطة (Admin)
 */
export async function updateAdminPlan(id, data) {
    const response = await axios.put(`/api/admin/plans/${id}`, data);
    return response.data.plan;
}

/**
 * 🟢 حذف خطة (Admin)
 */
export async function deleteAdminPlan(id) {
    const response = await axios.delete(`/api/admin/plans/${id}`);
    return response.data;
}


export async function fetchAcademyPage(academyId) {
  const res = await axios.get(`/api/public/academies/${academyId}`);
  return res.data;
}

/**
 * 🟢 جلب آراء الأكاديمية (Academy Admin)
 */
export async function fetchAcademyTestimonials() {
  const response = await axios.get("/api/academy/testimonials");
  return response.data.testimonials;
}

/**
 * 🟢 إضافة رأي جديد
 */
export async function createAcademyTestimonial(data) {
  const response = await axios.post(
    "/api/academy/testimonials",
    data
  );
  return response.data.testimonial;
}

/**
 * 🟢 تحديث رأي
 */
export async function updateAcademyTestimonial(id, data) {
  const response = await axios.put(
    `/api/academy/testimonials/${id}`,
    data
  );
  return response.data.testimonial;
}

/**
 * 🟢 حذف رأي
 */
export async function deleteAcademyTestimonial(id) {
  const response = await axios.delete(
    `/api/academy/testimonials/${id}`
  );
  return response.data;
}

/**
 * 🟢 جلب آخر 10 كورسات لأكاديمية (Public)
 */

export async function fetchAcademyLatestCourses(academyId) {
  const res = await axios.get(`/api/public/academies/${academyId}/latest-courses`);
  return res.data.courses; // 👈 رجّع array مباشرة
}
/**
 * 🟢 جلب الفئات الرئيسية للأكاديمية (Public)
 */
export async function fetchAcademyMainCategories(academyId) {
  const res = await axios.get(
    `/api/public/academies/${academyId}/main-categories`
  );
  return res.data.categories; // 👈 رجّع array مباشرة
}

/**
 * 🟢 جلب كورسات حسب الفئة
 */
export async function fetchCoursesByCategory(academyId, categoryId) {
  const res = await axios.get(
    `/api/public/academies/${academyId}/categories/${categoryId}/courses`
  );
  return res.data.courses;
}
